module.exports = __webpack_public_path__ + "img/top_haoping@3x.c7d5194e.png";